var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SeparatorIcon = function (props) {
    return _jsx("svg", __assign({ className: props.className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 198 156" }, { children: _jsx("path", { id: "Selection", fill: "#ff492d", stroke: "transparent", strokeWidth: "0", d: "M 84.00,5.44\n           C 130.03,-0.46 171.44,27.13 187.58,70.00\n             196.32,93.24 200.81,136.34 172.00,147.53\n             165.31,150.14 159.02,150.08 152.00,150.00\n             152.00,150.00 106.00,143.10 106.00,143.10\n             106.00,143.10 98.00,143.10 98.00,143.10\n             94.12,142.65 92.29,141.85 88.00,142.09\n             88.00,142.09 41.00,150.00 41.00,150.00\n             35.67,150.06 30.06,150.47 25.00,148.53\n             1.94,139.71 0.85,108.52 5.21,88.00\n             13.67,48.20 42.96,13.02 84.00,5.44 Z" }, void 0) }), void 0);
};
export default SeparatorIcon;
